import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Koşullu Tailwind sınıflarını birleştirir ve çakışanları sadeleştirir.
 * Elle string birleştirme yasaktır (docs/standards/frontend-standards.md §5).
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
